module.exports = __webpack_public_path__ + "071742d3a26ec98e5c120626e019b177.png";